import React, { useState} from "react";
import moment from "moment";
import defaultType1 from "../image/defaultType1.png";
import defaultType2 from "../image/defaultType2.png";

const Detail = (props) => {
  let data = props.data;
  const {
    content,
    title,
    publishDate,
    publishPhoto,
    publishType,
    variableFields,
    host
  } = data;
const [showDescribe,setShowDescribe]=useState(false)
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        height:"100%",
        flexDirection: "column",
        backgroundColor: "#000",
        alignItems:'center',
        justifyContent:"space-between",
        width:document.documentElement.clientWidth,
        maxWidth:677
      }}
    >
      <div
        style={{
          textAlign: "center",
          color: "#fff",
          fontSize: 12,
        }}
      >
        <div style={{ padding: 10,paddingBottom:0 }}>
          <span
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              wordBreak: "break-all",
              wordWarp: "break-word",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 1,
              fontSize: 16,
              color: "#fff",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {title}
          </span>
        </div>
        <div style={{margin:10 }}>
          <span style={{ marginRight: 10 }}>
            <img
              src={
                publishPhoto
                  ? publishPhoto
                  : publishType === 0
                  ? defaultType1
                  : defaultType2
              }
              style={{ width: 16, height: 16, verticalAlign: "middle" }}
              alt=""
            />
          </span>
          <span style={{ marginRight: 10 }}>{variableFields.publishName}</span>
          <span>{publishDate && moment(publishDate).format("YYYY-MM-DD")}</span>
        </div>
      </div>
      {variableFields && variableFields.videoUrl && (
        <video
          id="my-video"
          controls
          controlsList="nodownload"
          autoPlay={true}
          width={"96%"}
          src={host + variableFields.videoUrl}
        />
      )}
     <div style={{position:'relative',width:"100%",height:100}}>
     <div
        style={{
          color: "#fff",
          padding: "12px",
          fontWeight: 400,
          position: "absolute",
          bottom: "0px",
        }}
      >
        <span style={{fontSize:14,fontWeight:"400"}}>
        {content&& showDescribe? content: content.slice(0, 64)}
        </span>
        {
          content.length>64&&
          (showDescribe? (
            <span
              onClick={() => {
                setShowDescribe(false)
              }}
            >
              {" "}
              收起
            </span>
          ) : (
            <span
              onClick={() => {
                setShowDescribe(true)
              }}
            >
              ... 展开
            </span>
          ))
        }
        
          
      </div>
     </div>
    </div>
  );
};

export default Detail;
